var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-container"},[_c('div',{ref:"scroll",staticClass:"scroll-container-border sf-scrollbar",class:{ 'has-top': _vm.hasTop, 'has-bottom': _vm.hasBottom }},[_c('div',{ref:"container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }